module.exports = __webpack_public_path__ + "static/media/UG_Syllabus_MDM_SE_2023-24.69236ac7.pdf";